import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bb1a351"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Share" }
const _hoisted_2 = {
  key: 0,
  class: "ShareImage view-default"
}
const _hoisted_3 = {
  ref: "picture",
  class: "Picture"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "SharePreview view-default"
}
const _hoisted_6 = { class: "SharePreview__Inner view-default__inner" }
const _hoisted_7 = { class: "Picture" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  class: "SharePreview view-default"
}
const _hoisted_10 = { class: "ShareSelect view-default" }
const _hoisted_11 = { class: "ShareSelect__Background bg-gradient" }
const _hoisted_12 = { class: "Ticker" }
const _hoisted_13 = {
  id: "ShareSelect-Ticker-mask",
  maskUnits: "userSpaceOnUse",
  style: {"mask-type":"alpha"}
}
const _hoisted_14 = { ref: "ticker" }
const _hoisted_15 = {
  x: "0",
  y: "50%",
  fill: "url(#ShareSelect-Ticker-gradient)"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<g mask=\"url(#ShareSelect-Ticker-mask)\" data-v-1bb1a351><rect width=\"100%\" height=\"100%\" fill=\"url(#ShareSelect-Ticker-gradient)\" fill-opacity=\"0.5\" data-v-1bb1a351></rect></g><defs data-v-1bb1a351><linearGradient id=\"ShareSelect-Ticker-gradient\" x1=\"-1.25%\" y1=\"63.5%\" x2=\"76.25%\" y2=\"-30.333%\" gradientUnits=\"userSpaceOnUse\" data-v-1bb1a351><stop stop-color=\"#F6F3E4\" stop-opacity=\"0.62\" data-v-1bb1a351></stop><stop offset=\"0.21875\" stop-color=\"#F1CDFE\" data-v-1bb1a351></stop><stop offset=\"1\" stop-color=\"#4B71D2\" stop-opacity=\"0.67\" data-v-1bb1a351></stop></linearGradient></defs>", 2)
const _hoisted_18 = { class: "ShareSelect__Inner view-default__inner" }
const _hoisted_19 = { class: "Header" }
const _hoisted_20 = { class: "Picture" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "Sharers" }
const _hoisted_23 = { class: "Sharers__Label" }
const _hoisted_24 = { class: "Sharers__Cta" }
const _hoisted_25 = {
  key: 3,
  class: "view-default__inner"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "view-default__title" }, "Share in progress", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 4,
  class: "view-default__inner"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "view-default__title" }, "Share Error", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 5,
  class: "view-default__inner"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "view-default__title" }, "Share Success", -1))
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_btn = _resolveComponent("ui-btn")!
  const _component_ui_btn_secondary = _resolveComponent("ui-btn-secondary")!
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_btn_round = _resolveComponent("ui-btn-round")!
  const _component_inset_border = _resolveComponent("inset-border")!
  const _component_MiniMap = _resolveComponent("MiniMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.datauri)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("figure", _hoisted_3, [
            _createElementVNode("img", { src: _ctx.datauri }, null, 8, _hoisted_4)
          ], 512)
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.matches('share.preview'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("figure", _hoisted_7, [
              _createElementVNode("img", {
                src: _ctx.datauri,
                alt: ""
              }, null, 8, _hoisted_8)
            ]),
            _createVNode(_component_ui_btn, {
              class: "SharePreview__CtaSubmit",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('share.cta_submit')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.$store.getters['viewport/isDesktop'])
              ? (_openBlock(), _createBlock(_component_ui_btn_secondary, {
                  key: 0,
                  class: "SharePreview__CtaRestart",
                  direction: _ctx.UIBtnSecondaryDirection.BACKWARDS,
                  theme: _ctx.UIBtnSecondaryTheme.LIGHT,
                  onClick: _ctx.onCancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('share.cta_restart')), 1)
                  ]),
                  _: 1
                }, 8, ["direction", "theme", "onClick"]))
              : (_openBlock(), _createBlock(_component_ui_btn_round, {
                  key: 1,
                  type: "button",
                  class: "SharePreview__CtaRestart",
                  onClick: _ctx.onCancel
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('share.cta_restart')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_ui_icon, { name: "close" })
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.matches('share.upload'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(), _createElementBlock("svg", _hoisted_12, [
          _createElementVNode("mask", _hoisted_13, [
            _createElementVNode("g", _hoisted_14, [
              _createElementVNode("text", _hoisted_15, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                  return _createElementVNode("tspan", { key: n }, _toDisplayString(_ctx.$t('common.exhibition_name')) + " ", 1)
                }), 64))
              ])
            ], 512)
          ]),
          _hoisted_16
        ])),
        _createVNode(_component_inset_border)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _withDirectives(_createElementVNode("div", _hoisted_19, [
          _createVNode(_component_ui_btn_round, {
            tag: "a",
            class: "UIBtnDownload",
            onClick: _ctx.onDownload,
            href: _ctx.datauri,
            download: ""
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('share.cta_download')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_icon, { name: "download" })
            ]),
            _: 1
          }, 8, ["onClick", "href"])
        ], 512), [
          [_vShow, !_ctx.hideDownload]
        ]),
        _createElementVNode("figure", _hoisted_20, [
          _createElementVNode("img", {
            src: _ctx.datauri,
            alt: ""
          }, null, 8, _hoisted_21)
        ]),
        _createVNode(_component_ui_btn, {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.send('GOTO_GALLERY')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('share.cta_gallery')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('share.share_title')), 1),
          _createElementVNode("div", _hoisted_24, [
            (_ctx.Viewport.isDesktop && _ctx.shareUrl)
              ? (_openBlock(), _createBlock(_component_ui_btn_secondary, {
                  key: 0,
                  type: "button",
                  disabled: _ctx.imgUploaded ? 'enable' : 'disable',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doShare('facebook')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.imgUploaded ? _ctx.$t('share.cta_facebook') : _ctx.$t('share.uploading')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : (_ctx.supportWebShareAPI && _ctx.shareUrl)
                ? (_openBlock(), _createBlock(_component_ui_btn_secondary, {
                    key: 1,
                    type: "button",
                    disabled: _ctx.imgUploaded ? 'enable' : 'disable',
                    onClick: _ctx.openSharer
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.imgUploaded ? _ctx.$t('share.cta_facebook') : _ctx.$t('share.uploading')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_MiniMap, {
          data: _ctx.mapPosition,
          animate: false
        }, null, 8, ["data"])
      ])
    ], 512), [
      [_vShow, _ctx.state.matches('share.upload') || _ctx.state.matches('share.select') || _ctx.state.matches('gallery_loading.fromshare')]
    ]),
    (_ctx.state.matches('share.pending'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
      : _createCommentVNode("", true),
    (_ctx.state.matches('share.error'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
      : _createCommentVNode("", true),
    (_ctx.state.matches('share.success'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
      : _createCommentVNode("", true)
  ]))
}